import React, { useCallback, useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import dayjs from 'dayjs'
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)
import { Link, useSearchParams, useNavigate, useParams } from 'react-router-dom'
import { Formik, Field } from 'formik'
import * as UpChunk from '@mux/upchunk'
import { colors, getDisplaySize } from '../ui/helpers.js'
import { H1, H2, H3, H6, Text, Span, GradientFont, Error, SmallTitle } from '../ui/Typography.js'
import { Flex, Box, Container } from '../ui/Layout.js'
import Image from '../ui/Image.js'
import { Input, TextArea } from '../ui/Input.js'
import Icon from '../ui/Icon.js'
import CodeCopy, { copyOnClick } from '../ui/CodeCopy.js'
import Button from '../ui/Button.js'
import { BigDarkSpinner } from '../ui/Spinner.js'
import Toggle from '../ui/Toggle.js'
import Select from '../ui/Select.js'
import ColorPicker from '../ui/ColorPicker.js'
import formikFormWrapper from '../formikFormWrapper.js'
import { toast } from 'react-toastify'
import { useModal } from '../Modal.js'
import ModalContainer from '../ui/ModalContainer.js'
import { useAuth } from '../Auth.js'
import api from '../api.js'

const OverduePaymentModal = () => {
  const { user, setUser, subscription } = useAuth()

  const goToStripePortal = async () => {
    const res = await api.get('/stripe/create-portal-session')
    if (res.data.success) {
      window.location.href = res.data.payload
    }
  }

  return (
    <ModalContainer
      noClose
      autoHeight
      width="518px"
      p={40}
      isOpen={subscription?.isOverdue}
      setIsOpen={() => null}
      zIndexOveride={1000000}
    >
      <Flex flexDirection="column">
        <Flex alignItems="center" mb="16px">
          <Icon icon="credit-card-red" width="24px" height="24px" />
          <Text fontSize="16px" fontWeight="600" ml="16px" color={colors.red}>
            Please review your latest payment
          </Text>
        </Flex>
        <Text light mb="32px">
          Your subscription is now {subscription?.daysOverdue} days past due. Please rectify your payment to reactivate your
          account. After 14 days your campaigns may be paused. If you require further assistance please contact support.
        </Text>
        <Button variant="black" width="161px" large label="Update payment" onClick={goToStripePortal} />
      </Flex>
    </ModalContainer>
  )
}

export default OverduePaymentModal
